import { useNavigate } from 'react-router';

import fail from '../../../assets/images/failIcon.svg';
import { closePopup } from '../../../store/slices/popupSlice';
import { useAppDispatch } from '../../../store/store';
import RedButton from '../../ui/buttons/redButton/RedButton';
import styles from './styles/styles.module.css';

function NegativeBalancePopup() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleClosePopup = () => {
    dispatch(closePopup());
  };
  const handleNavigateWalletPopup = () => {
    dispatch(closePopup());
    navigate('/balance');
  };

  return (
    <div className={styles.failPopupWrapper}>
      <button
        className={styles.closePopupButton}
        onClick={handleClosePopup}
        aria-label="Закрыть"
      />
      <div className={styles.failTextWrapper}>
        <img src={fail} alt="иконка красный крестик" />
        <h2 className={styles.failTitle}>Создать заказ невозможно!</h2>
        <h3 className={styles.failSubTitle}>
          У вас есть непогашенная задолженность. Пожалуйста, погасите её, чтобы продолжить
          пользоваться нашими услугами
        </h3>
      </div>
      <RedButton
        text="Перейти к пополнению"
        onClick={handleNavigateWalletPopup}
        width={308}
        height={50}
      />
    </div>
  );
}

export default NegativeBalancePopup;
